import axios from 'axios'
import { setupInterceptorsTo } from './helper.js'

const aiAssistApi = setupInterceptorsTo(
  axios.create({
    baseURL: process.env.REACT_APP_AIASSISTANT_BASEURL,
    headers: {
      'Content-Type': 'application/json',
    },
  }),
  'AI_ASSISTANT',
)

export async function getAiAssist(url, config = {}) {
  return await aiAssistApi
    .get(url, {
      ...config,
    })
    .then((response) => response.data)
    .catch((e) => {
      console.error(e)
      return e
    })
}

export async function postAiAssist(url, data, config = {}) {
  return aiAssistApi
    .post(url, { ...data }, { ...config })
    .then((response) => {
      return response.data
    })
    .catch((e) => {
      console.error(e)
      return e.response
    })
}

export async function putAiAssist(url, data, config = {}) {
  return aiAssistApi
    .put(url, { ...data }, { ...config })
    .then((response) => response.data)
    .catch((e) => {
      console.error(e)
      return e
    })
}
